import React, { useEffect, useRef } from 'react';
import ArticleCardBase from '../../Base';
import CardMedia from '../../../../CardMedia';
import { inheritChildStyle } from '../../../../../helpers/text';

import './styles.scss';

const PortraitImageCard3 = ({ data, endCard }) => {
  const captionTextRef = useRef();
  const { backgroundColor, caption, paragraphC7, articleAsset, imageFit } = data;

  useEffect(() => {
    if (captionTextRef.current) {
      inheritChildStyle(captionTextRef.current, 'a', 'color');
    }
  }, []);

  return (
    <ArticleCardBase variation="portrait" accentColor1={backgroundColor} endCard={endCard}>
      <section className="card-container portrait-image-card-3">
        <div
          ref={captionTextRef}
          className="portrait-image-card-3__caption"
          dangerouslySetInnerHTML={{ __html: caption }}
        />
        <div
          className="portrait-image-card-3__description"
          dangerouslySetInnerHTML={{ __html: paragraphC7 }}
        />
        {articleAsset.length ? (
          <div className="portrait-image-card-3__asset-wrapper">
            <CardMedia
              url={articleAsset[0].url}
              title={articleAsset[0].title}
              mimeType={articleAsset[0].mimeType}
              mediaContainerClasses="portrait-image-card-3__media-container"
              mediaClasses="portrait-image-card-3__media"
              imageFit={imageFit}
              cardImageSizes={[{ actual: 327, intrinsic: 780 }]}
              loop
              isAutoplay
            />
          </div>
        ) : null}
      </section>
    </ArticleCardBase>
  );
};

export default PortraitImageCard3;
